import React, { FC, useEffect, useState } from "react";
import { Table, Block, TextInput } from "@trane/trane-components/dist";
import { Dashboard } from "./Dashboard.d";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

export interface DashboardTableProps {
  rows: Array<Dashboard>;
  labels: any;
}

export const DashboardTable: FC<DashboardTableProps> = (props, history) => {
  const { labels, rows } = props;
  const [loading, setLoading] = useState(false);
  const [sortedData, setSortedData] = useState([] as Array<Dashboard>);

  useEffect(() => {
    setSortedData(rows);
    setLoading(true);
    formatTraneTable(rows);
  }, [rows]);

  const [componentData, setComponentData] = useState<Array<any>>([]);

  const sortedName = (value) => {
    let newData;
    if (!value) {
      newData = sortedData.sort((a, b) => {
        let aLabel = a.title.toUpperCase();
        let bLabel = b.title.toUpperCase();
        return aLabel > bLabel ? -1 : aLabel < bLabel ? 1 : 0;
      });
    } else {
      newData = sortedData.sort((a, b) => {
        let aLabel = a.title.toUpperCase();
        let bLabel = b.title.toUpperCase();
        return aLabel < bLabel ? -1 : aLabel > bLabel ? 1 : 0;
      });
    }
    setSortedData(newData);
    formatTraneTable(newData);
  };

  const headerColumns = [
    { title: <TextInput type="checkBox" />, disabled: true },
    {
      title: labels["Dashboard.Name.Text"] || "Name",
    },
    {
      title: labels["LastModified.Text"],
      disabled: true,
    },
    {
      title: labels["Description.Text"],
      disabled: true,
    },
  ];

  const OnPremiseRedirectToActionSettings = () => {
    const url = window.location.href.slice(
      0,
      window.location.href.indexOf("React")
    );
    window.location.href = url + "DataVisualization/Dashboard.aspx";
  };

  const formatTraneTable = (rows: Array<Dashboard>) => {
    let data: Array<any> = [[]];
    console.log(rows);

    rows.forEach((element) => {
      data.push([
        {
          title: <TextInput type="checkBox" />,
        },
        { title: element.title },
        {
          title: element.lastModifiedString,
        },
        { title: element.description },
      ]);
    });

    setComponentData(data);
    setLoading(false);
  };

  return (
    <Block
      display="flex"
      width="calc(100% - 40px)"
      padding="20px"
      justify="flex-start"
    >
      <Table
        title={"Manage Dashboard"}
        actionText="Create Dashboard"
        action={() => {
          OnPremiseRedirectToActionSettings();
        }}
        search={true}
        header={headerColumns}
        rows={componentData}
      />
    </Block>
  );
};

export default DashboardTable;
